var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({attrs:{"id":"appConfirmBtn","rounded":"","color":"primary"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(" Salvar ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }